
import React from 'react';
import { StatsCard } from './StatsCard';
import { StatCardData } from '@/types/crm';
import { DollarSign, Zap, Target, CalendarDays } from 'lucide-react'; // Zap for Active Opps, Target for Conversion, CalendarDays for Meetings

const statsData: StatCardData[] = [
  { title: 'Total Revenue', value: '$2,847,000', change: '+12.5% from last month', changeType: 'positive', icon: DollarSign },
  { title: 'Active Opportunities', value: '47', change: '+3 from last month', changeType: 'positive', icon: Zap },
  { title: 'Conversion Rate', value: '68%', change: '-2.1% from last month', changeType: 'negative', icon: Target },
  { title: 'Meetings This Week', value: '23', change: '+5 from last month', changeType: 'positive', icon: CalendarDays },
];

export const StatsCardsRow: React.FC = () => {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4 mb-6">
      {statsData.map((stat) => (
        <StatsCard key={stat.title} {...stat} />
      ))}
    </div>
  );
};

